/*
 * ReferralInsufficientFundsStyles.js
 *
 * @providesModule ReferralInsufficientFundsStyle
 * 
 */

import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';

import {
  StyleSheet,
} from 'react-native';

const {
  fontPrimaryItalic,
  fontSecondary,
  fontRegular,
  btnTextColorOne,
  btnTextColorTwo,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  fontSizeH5,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  outerContainer: {
    margin: Sizes.select({
      tablet: 20,
      phone: 15
    }),
  },

  infoContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  infoText: {
    ...fontRegular,
    ...Sizes.select({
      tablet: fontSizeH3,
      phone: fontSizeH4
    }),
    color: 'rgb(51, 51, 51)',
    textAlign: 'center',
  },

  validText: {
    marginTop: Sizes.select({
      tablet: 16,
      phone: 8
    }),
    ...fontPrimaryItalic,
    ...Sizes.select({
      tablet: fontSizeH4,
      phone: fontSizeH5
    }),
    color: 'rgb(51, 51, 51)',
    textAlign: 'center',
  },

  buttonContainer: {
    flexDirection: 'row',
  },

  backButton: {
    flex: 1,
    height: Sizes.select({
      tablet: 44,
      phone: 34
    }),
    marginTop: Sizes.select({
      tablet: 20,
      phone: 15
    }),
    marginRight: Sizes.select({
      tablet: 20,
      phone: 15
    }),
  },

  nextButton: {
    flex: 1,
    height: Sizes.select({
      tablet: 44,
      phone: 34
    }),
    marginTop: Sizes.select({
      tablet: 20,
      phone: 15
    }),
  },

  backButtonText: {
    ...fontSecondary,
    ...btnTextColorTwo,
    ...Sizes.select({
      tablet: fontSizeH2,
      phone: fontSizeH3
    }),
  },

  nextButtonText: {
    ...fontSecondary,
    ...btnTextColorOne,
    ...Sizes.select({
      tablet: fontSizeH2,
      phone: fontSizeH3
    }),
  },
});
